import React from 'react'
import { PageHeader, Card } from '@pilot-hub/ui'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'

interface Drone {
  id: number
  name: string
  lat: number
  lng: number
  altitude: number
  speed: number
  battery: number
  signal: number
  status: 'active' | 'warning'
}

export function TelemetryPage() {
  const drones: Drone[] = [
    { id: 1, name: 'DJI Matrice 30T', lat: 52.5200, lng: 13.4050, altitude: 120, speed: 15, battery: 78, signal: 94, status: 'active' },
    { id: 2, name: 'Mavic 3E', lat: 52.5250, lng: 13.4100, altitude: 85, speed: 8, battery: 45, signal: 89, status: 'active' },
    { id: 3, name: 'Mavic 3E', lat: 52.5180, lng: 13.3980, altitude: 45, speed: 0, battery: 22, signal: 78, status: 'warning' },
  ]

  const center: [number, number] = [52.5200, 13.4050]

  return (
    <div className="space-y-6">
      <PageHeader
        title="Live Telemetrie"
        subtitle="Echtzeit-Überwachung aller aktiven Drohnen"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <Card className="p-4">
          <p className="text-sm text-gray-500 dark:text-gray-400">Aktive Drohnen</p>
          <p className="text-3xl font-bold text-blue-400">3</p>
        </Card>
        <Card className="p-4">
          <p className="text-sm text-gray-500 dark:text-gray-400">Luftraum-Verstöße</p>
          <p className="text-3xl font-bold text-red-400">0</p>
        </Card>
        <Card className="p-4">
          <p className="text-sm text-gray-500 dark:text-gray-400">Signalstärke Ø</p>
          <p className="text-3xl font-bold text-green-400">94%</p>
        </Card>
        <Card className="p-4">
          <p className="text-sm text-gray-500 dark:text-gray-400">Batterie Ø</p>
          <p className="text-3xl font-bold text-yellow-400">67%</p>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="lg:col-span-2">
          <div className="card-header">
            <div className="card-title">Live Karte</div>
          </div>
          <div className="card-content">
            <MapContainer center={center} zoom={13} className="h-[600px] w-full rounded-lg">
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              {drones.map(drone => (
                <Marker key={drone.id} position={[drone.lat, drone.lng]}>
                  <Popup>
                    <div className="p-2">
                      <p className="font-bold">{drone.name}</p>
                      <p>Höhe: {drone.altitude}m</p>
                      <p>Geschwindigkeit: {drone.speed} km/h</p>
                      <p>Batterie: {drone.battery}%</p>
                      <p>Signal: {drone.signal}%</p>
                      <p className={drone.status === 'warning' ? 'text-yellow-400' : 'text-green-400'}>
                        Status: {drone.status === 'warning' ? 'Warnung: Niedrige Batterie' : 'Aktiv'}
                      </p>
                    </div>
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          </div>
        </Card>

        <Card>
          <div className="card-header">
            <div className="card-title">Drohnen-Details</div>
          </div>
          <div className="card-content space-y-4">
            {drones.map(drone => (
              <div key={drone.id} className="p-4 bg-gray-100 dark:bg-gray-800 rounded-lg">
                <div className="flex items-center justify-between">
                  <h4 className="font-semibold">{drone.name}</h4>
                  <span className={`badge ${drone.status === 'warning' ? 'badge-warning' : 'badge-success'}`}>
                    {drone.status === 'warning' ? 'Warnung' : 'Aktiv'}
                  </span>
                </div>
                <div className="grid grid-cols-3 gap-2 text-sm mt-3">
                  <div className="p-2 bg-gray-100 dark:bg-gray-800 rounded">
                    <p className="text-gray-500 dark:text-gray-400">Höhe</p>
                    <p className="font-mono">{drone.altitude}m</p>
                  </div>
                  <div className="p-2 bg-gray-100 dark:bg-gray-800 rounded">
                    <p className="text-gray-500 dark:text-gray-400">Geschwindigkeit</p>
                    <p className="font-mono">{drone.speed} km/h</p>
                  </div>
                  <div className="p-2 bg-gray-100 dark:bg-gray-800 rounded">
                    <p className="text-gray-500 dark:text-gray-400">Batterie</p>
                    <p className="font-mono">{drone.battery}%</p>
                  </div>
                  <div className="p-2 bg-gray-100 dark:bg-gray-800 rounded">
                    <p className="text-gray-500 dark:text-gray-400">Signal</p>
                    <p className="font-mono">{drone.signal}%</p>
                  </div>
                  <div className="p-2 bg-gray-100 dark:bg-gray-800 rounded">
                    <p className="text-gray-500 dark:text-gray-400">Status</p>
                    <p className="font-mono">{drone.status === 'warning' ? 'Warnung' : 'Aktiv'}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  )
}